import { Component, ElementRef, OnInit, Renderer2, ViewChild } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { UserService } from "../services/user.service";
import { HttpErrorResponse } from "@angular/common/http";
import { Validators, FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { Router } from "@angular/router";
import { CommunicationService } from "../services/communication.service";
import { CommonModule } from "@angular/common";
import { SeamlessHeaderComponent } from "../shared/seamless-header.component";
import { ProductService } from "../services/product.service";

@Component({
  selector: "app-income-screen",
  templateUrl: "./income-screen.component.html",
  styleUrls: ["./income-screen.component.css"],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, SeamlessHeaderComponent]
})
export class IncomeScreenComponent implements OnInit {
  @ViewChild('updateIncomeInfoModal', { static: false }) updateIncomeInfoModal: ElementRef;

  // Salary variable to bind with the input
  salary: number | null = null;
  salaryDisplay: string = '';
  userName = "";
  userData = null;
  updateIncomeForm;
  setPosition = false;
  dcStatus; splStatus; dcEligibility; splEligibility; capfinStatus;
  isSplContractPending;
  constructor(private router: Router,
    private modalService: NgbModal,
    private userService: UserService,
    private formBuilder: FormBuilder,
    private productService: ProductService,
    private communicationService: CommunicationService,
    private el: ElementRef, private renderer: Renderer2
  ) { }
  moved = false;
  displayIncomeSection = false;
  get updateIncomeFormControls() { return this.updateIncomeForm.controls; }
  ngOnInit() {

    this.productService.getProductsQualify().subscribe({
      next: (data: any) => {
        this.BindProductQualify(data);
      }
    });

    localStorage.setItem('PageUrls', 'onboarding');
    let userDataStr = localStorage.getItem('apiUserModel');
    this.userData = userDataStr ? JSON.parse(userDataStr) : null;
    this.userName = this.userData?.given_name;

    this.updateIncomeForm = this.formBuilder.group({
      GrossIncome: ['', [Validators.required, Validators.min(0)]],
    });

    setTimeout(() => {
      this.moved = true;
    }, 2000);
    setTimeout(() => {
      this.displayIncomeSection = true;
      this.setPosition = true;
      this.renderer.addClass(this.el.nativeElement, 'bg-active');
    }, 2500);
  }

  private BindProductQualify(data: any) {
    if (data != null) {
      this.dcStatus = data.dcResponse;
      this.splStatus = data.splResponse;
      this.isSplContractPending = this.splStatus?.isInPendindingState;

      this.dcEligibility = this.dcStatus?.criteria?.toLowerCase() == 'no-yes';
      this.splEligibility = this.splStatus?.criteria?.toLowerCase() == 'approve' || this.splStatus?.criteria?.toLowerCase() == 'maybe-high';
      this.capfinStatus = data.capfinResponse;
      sessionStorage.setItem('loadProductsQualify', JSON.stringify(data));
    }
  }
  openUpdateIncomeInfoModal() {
    this.modalService.open(this.updateIncomeInfoModal, {
      backdrop: 'static',
      backdropClass: 'customBackdrop',
      keyboard: false
    });
  }
  // Handle input formatting
  onSalaryInput(event: any) {
    // Remove all non-numeric characters
    const numericOnly = event.target.value.replace(/[^0-9]/g, '');

    // If input is completely empty set salary to null
    if (numericOnly === '') {
      this.salary = null;
      this.salaryDisplay = '';
      this.updateIncomeForm.patchValue({ GrossIncome: '' });
      return;
    }

    let numericValue = parseInt(numericOnly);

    if (numericValue > 999999) {
      numericValue = 999999;
    }

    this.salary = numericValue;

    this.salaryDisplay = numericValue > 0 ? this.formatNumber(numericValue) : '0';
    this.updateIncomeForm.patchValue({ GrossIncome: this.salaryDisplay });

    setTimeout(() => {
      event.target.setSelectionRange(this.salaryDisplay.length, this.salaryDisplay.length);
    }, 0);
  }

  formatNumber(value: string | number): string {
    const num = typeof value === 'string' ? parseInt(value) : value;
    return num.toLocaleString('en-US');
  }

  formatSalaryDisplay() {
    if (this.salary === null || this.salary === undefined || this.salary < 0) {
      this.salaryDisplay = '';
      this.updateIncomeForm.patchValue({ GrossIncome: '' });
    } else {
      this.salaryDisplay = this.formatNumber(this.salary);
      this.updateIncomeForm.patchValue({ GrossIncome: this.salaryDisplay });
    }
  }

  allowNumbersOnly(event: any) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }


  finishSetup() {
    if (this.updateIncomeForm.invalid) {
      this.updateIncomeForm.markAllAsTouched();
      return;
    }

    this.userService.updateGrossIncome(this.updateIncomeForm.value).subscribe({
      next: (data: any) => {
        this.userService.getDebtConsolidation().subscribe({
          next: (data: any) => {
            sessionStorage.setItem('loadUserType', JSON.stringify(data));

            this.dcEligibility = data?.dbClient == 'No' && data?.dbC_Conversion == 'Yes';

            let IsFramerFlow = sessionStorage.getItem('IsFramerFlow') === 'true' || localStorage.getItem('IsFromOtpScreen') === 'true';
            if (this.dcEligibility && !IsFramerFlow) {
              this.router.navigate(['/reducedebt']);
            }
            else if (this.splEligibility && !this.isSplContractPending) {
              this.router.navigate(['/reducedebt-spl']);
            }
            else if (this.capfinStatus?.criteria == "550-10000") {
              this.router.navigate(['/reducedebt-capfin']);
            }
            else {
              this.router.navigate(['/reducedebt-spl']);
            }
          }
        });
      }, error: (err: HttpErrorResponse) => {

      }
    });


  }


}
